(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-game-card/assets/javascripts/components/casino-game-card-badge.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-game-card/assets/javascripts/components/casino-game-card-badge.js');

'use strict';

const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_SM = _svs$components$lbUti.BREAKPOINT_SM;
const formatCurrency = svs.utils.format.Currency;
const CasinoGameCardBadge = _ref => {
  let badge = _ref.badge,
    jackpotData = _ref.jackpotData;
  const smallScreen = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  if (badge && jackpotData !== null && jackpotData !== void 0 && jackpotData.amount) {
    return React.createElement("div", {
      className: "casino-game-card-badge"
    }, !smallScreen && React.createElement("div", {
      className: "casino-game-card-badge__text casino-game-card-badge__text--badge"
    }, badge), React.createElement("div", {
      className: "casino-game-card-badge__text casino-game-card-badge__text--jackpot casino-game-card-badge__text--alternative"
    }, formatCurrency(jackpotData.amount), ' ', "kr"));
  }
  if (badge) {
    return React.createElement("div", {
      className: "casino-game-card-badge"
    }, React.createElement("div", {
      className: "casino-game-card-badge__text"
    }, badge));
  }
  if (jackpotData !== null && jackpotData !== void 0 && jackpotData.amount) {
    return React.createElement("div", {
      className: "casino-game-card-badge"
    }, React.createElement("div", {
      className: "casino-game-card-badge__text casino-game-card-badge__text--alternative"
    }, formatCurrency(jackpotData.amount), ' ', "kr"));
  }
  return null;
};
setGlobal('svs.components.casino_react.casinoGameCard.CasinoGameCardBadge', CasinoGameCardBadge);

 })(window);